/**
 * Retorna a profundidade máxima da árvore.
 * @param {Object|Array} data - Um nó único ou um array de nós (raízes).
 * @param {string} childrenKey - Nome da propriedade que contém os filhos.
 * @returns {number} - Número de níveis (1 para um único nó).
 */
function maxDepth(data, childrenKey) {
  // Se vier um array de raízes, calcula o máximo entre elas
  if (Array.isArray(data)) {
    if (data.length === 0) return 0; // nenhuma raiz => profundidade 0
    return Math.max(...data.map(node => maxDepth(node, childrenKey)));
  }

  // Se vier um nó único
  if (!data || typeof data !== 'object') return 0;

  const kids = data?.[childrenKey];
  if (!Array.isArray(kids) || kids.length === 0) {
    return 1; // nó folha
  }

  // 1 (este nó) + maior profundidade dentre os filhos
  return 1 + Math.max(...kids.map(child => maxDepth(child, childrenKey)));
}

export default maxDepth;